import { type HTMLProps, type PropsWithChildren, type ReactNode } from 'react';

type FormProps = PropsWithChildren & HTMLProps<HTMLFormElement>;

/**
 * Coupon form wrapper.
 *
 * @param root0 the input props
 * @param root0.children the children to pass down
 * @param root0.props the additional props to pass down
 * @returns form element with children passed down.
 */
export default function CouponForm({ children, ...props }: FormProps): ReactNode {
  return (
    <form id={props.id ?? 'coupon_form'} {...props}>
      {children}
    </form>
  );
}
